<template>
    <svg id="talk" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 18.955 16.112">
        <path id="Path_70108" data-name="Path 70108"
              d="M16.112,3.659H11.689V3.343A2.847,2.847,0,0,0,8.846.5h-6A2.847,2.847,0,0,0,0,3.343V7.134A2.847,2.847,0,0,0,2.843,9.977h.316V12.5a.316.316,0,0,0,.539.223L6.449,9.977h.817v.316a2.847,2.847,0,0,0,2.843,2.843h1.765l3.382,3.382A.316.316,0,0,0,15.8,16.3V13.137h.316a2.847,2.847,0,0,0,2.843-2.843V6.5a2.847,2.847,0,0,0-2.843-2.843ZM6.318,9.346a.316.316,0,0,0-.223.093l-2.3,2.3V9.661a.316.316,0,0,0-.316-.316H2.843A2.214,2.214,0,0,1,.632,7.134V3.343A2.214,2.214,0,0,1,2.843,1.132h6a2.214,2.214,0,0,1,2.211,2.211v.316h-.948A2.847,2.847,0,0,0,7.266,6.5V9.346Zm12,.948A2.214,2.214,0,0,1,16.112,12.5H15.48a.316.316,0,0,0-.316.316v2.712L12.228,12.6A.316.316,0,0,0,12,12.5h-1.9A2.214,2.214,0,0,1,7.9,10.293V6.5a2.214,2.214,0,0,1,2.211-2.211h6A2.214,2.214,0,0,1,18.323,6.5Zm0,0"
              transform="translate(0 -0.5)" fill="#fff"/>
        <path id="Path_70109" data-name="Path 70109"
              d="M239.582,144.5h-7.266a.316.316,0,1,0,0,.632h7.266a.316.316,0,0,0,0-.632Zm0,0"
              transform="translate(-222.839 -138.814)" fill="#fff"/>
        <path id="Path_70110" data-name="Path 70110"
              d="M239.582,192.5h-7.266a.316.316,0,1,0,0,.632h7.266a.316.316,0,0,0,0-.632Zm0,0"
              transform="translate(-222.839 -184.918)" fill="#fff"/>
        <path id="Path_70111" data-name="Path 70111"
              d="M239.582,240.5h-7.266a.316.316,0,0,0,0,.632h7.266a.316.316,0,0,0,0-.632Zm0,0"
              transform="translate(-222.839 -231.023)" fill="#fff"/>
        <path id="Path_70112" data-name="Path 70112"
              d="M40.316,65.132H46.95a.316.316,0,0,0,0-.632H40.316a.316.316,0,1,0,0,.632Zm0,0"
              transform="translate(-38.42 -61.973)" fill="#fff"/>
        <path id="Path_70113" data-name="Path 70113"
              d="M45.055,112.5H40.316a.316.316,0,1,0,0,.632h4.739a.316.316,0,0,0,0-.632Zm0,0"
              transform="translate(-38.42 -108.077)" fill="#fff"/>
        <path id="Path_70114" data-name="Path 70114"
              d="M44.739,160.5H40.316a.316.316,0,1,0,0,.632h4.423a.316.316,0,1,0,0-.632Zm0,0"
              transform="translate(-38.42 -154.182)" fill="#fff"/>
    </svg>

</template>

<script>
    export default {
        name: "IConversation",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
